import { options_premiumSubOption_Features } from './PremiumDashboardFeaturesSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { PremiumStorageOptionApril } from 'owa-premium-storage-option';
import { SubscriptionOptionApril } from 'owa-subscription-option';
import { DomainEnrollOption } from 'owa-domain-option';
import { fetchAndValidateDomain } from 'owa-domain-option';
import { getSubscriberType } from 'owa-domain-option';
import { getPremiumUser } from 'owa-domain-option';
import { PremiumSupportOption } from 'owa-premium-support-option';
import { trace } from 'owa-trace';
import { getPremiumSupportFlightStatus } from 'owa-premium-support-option';
import { CloudCacheOption } from 'owa-cloud-cache-accounts-option/lib/CloudCacheOption';
import { lazyGetAccountInformation } from 'owa-storage-store';
import getFolderStorageInformation from 'owa-storage-option/lib/actions/getFolderStorageInformation';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logUsage } from 'owa-analytics';

let premiumDashboardFeaturesSubCategory: OptionSubCategory = {
    key: 'features',
    titleStringKey: options_premiumSubOption_Features,
    options: [
        SubscriptionOptionApril, // The subscription Information is displayed at the top of the storage information.
        PremiumSupportOption,
        CloudCacheOption,
        DomainEnrollOption,
        PremiumStorageOptionApril, // Make sure mailbox cleanup is the last thing shown.
    ],
    onSelected: () => {
        return loadPremiumFeatureDashBoard();
    },
    refreshOnSelected: true,
};

async function loadPremiumFeatureDashBoard(): Promise<boolean> {
    try {
        const isShowingMailboxCleanup = isFeatureEnabled('tri-mailboxCleanup');
        logUsage('MailboxCleanup_Impression', [isShowingMailboxCleanup]);

        fetchAndValidateDomain();
        getPremiumUser();
        getSubscriberType();
        const featuresPromises: Promise<any>[] = [];
        featuresPromises.push(lazyGetAccountInformation.importAndExecute());
        if (isShowingMailboxCleanup) {
            featuresPromises.push(getFolderStorageInformation());
        }
        featuresPromises.push(getPremiumSupportFlightStatus());
        await Promise.all(featuresPromises);
        return true;
    } catch (e) {
        trace.warn(e.message);
        return false;
    }
}

export default premiumDashboardFeaturesSubCategory;
